
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcAdviceButton as ObcAdviceButtonElement} from '@oicl/openbridge-webcomponents/dist/components/advice-button/advice-button.js';
 import {AdviceButtonClickEvent} from '@oicl/openbridge-webcomponents/dist/components/advice-button/advice-button.js';
 export type {AdviceButtonClickEvent} from '@oicl/openbridge-webcomponents/dist/components/advice-button/advice-button.js';
 

 
 export const ObcAdviceButton = createComponent({
   react: React,
   tagName: 'obc-advice-button',
   elementClass: ObcAdviceButtonElement,
   events: {
     
     onObcClick: 'obc-click' as EventName<AdviceButtonClickEvent>,
   }
  });
 
 